import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/rbac.json';
import ar from './i18n/ar/rbac.json';

registerFeatureI18n('rbac', { en, ar });

export { RolesPage } from './RolesPage';
